module.exports = __webpack_public_path__ + "static/media/edit.dcc524e3.svg";